<template>
  <template v-if="uiLoading">
    <div
      :class="[ns.b(), ns.is('animated', animated)]"
      v-bind="$attrs"
      data-test-name="skeleton"
      data-test-variant=""
      data-test-state=""
    >
      <slot v-if="count === 1" name="template">
        <b-skeleton-item :class="ns.is('first')" variant="p" />
        <b-skeleton-item
          v-for="item in rows"
          :key="item"
          :class="[ns.e('paragraph'), ns.is('last', item === rows && rows > 1)]"
          variant="p"
        />
      </slot>
      <b-space v-else wrap :gutter="gutter">
        <div v-for="i in count" :key="i">
          <slot v-if="loading" :key="i" name="template">
            <b-skeleton-item :class="ns.is('first')" variant="p" />
            <b-skeleton-item
              v-for="item in rows"
              :key="item"
              :class="[
                ns.e('paragraph'),
                ns.is('last', item === rows && rows > 1),
              ]"
              variant="p"
            />
          </slot>
        </div>
      </b-space>
    </div>
  </template>
  <template v-else>
    <slot v-bind="$attrs" />
  </template>
</template>

<script lang="ts" setup>
import { toRef } from 'vue'
import { useNamespace, useThrottleRender } from '@bigin/hooks'
import BSpace from '../../space'
import { skeletonProps } from './skeleton'
import BSkeletonItem from './skeleton-item.vue'

defineOptions({
  name: 'BSkeleton',
})
const props = defineProps(skeletonProps)

const ns = useNamespace('skeleton')
const uiLoading = useThrottleRender(toRef(props, 'loading'), props.throttle)

defineExpose({
  /** @description loading state */
  uiLoading,
})
</script>
